
export const global = {
    name: 'global',
    store() {
    return {
      isMobileMenuVisible: false,
      isMinicartVisible: false,
      isPredictiveSearchVisible: false,
      isWindowScrolled: false,
      hasAccountPopupLogin: false,
      hasAccountPopupRegister: false,
      cart: null,
        currencyManager: null,
      init() {

        window.addEventListener('scroll', this.onWindowScrollHandler.bind(this))
        window.addEventListener('keydown', this.onKeyDownHandler.bind(this))
        window.addEventListener('mobile-menu-open', this.openMobileMenu)
        window.addEventListener('mobile-menu-closed', this.closeMobileMenu)

        const accountPopupLogin = document.querySelector('.account-popup-login');
        this.hasAccountPopupLogin = accountPopupLogin !== null;

        const accountPopupRegister = document.querySelector('.account-popup-register');
        this.hasAccountPopupRegister = accountPopupRegister !== null;

        window.addEventListener("toggle-display-open", this.accountPopupFallback.bind(this));

        this.initLiquidAJaxCart()
        this.listenToCart()
      },
      get bodyClasses() {
        let classes = []

        if (this.isMobileMenuVisible) {
          classes.push('mobile-menu-visible')
        }
          if (this.isMinicartVisible) {
              classes.push('minicart-open')
          }
          if (this.isPredictiveSearchVisible) {
              classes.push('search-open')
          }

        return classes || ''
      },
      openMobileMenu() {
        this.isMobileMenuVisible = true
          document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('mobile-menu-visible')
          document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('no-scroll__menu')
      },
      closeMobileMenu() {
        this.isMobileMenuVisible = false
          document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('mobile-menu-visible')
          document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('no-scroll__menu')
      },
      toggleMobileMenu() {
        this.isMobileMenuVisible = !this.isMobileMenuVisible
      },
      toggleSearch() {
        this.isPredictiveSearchVisible = !this.isPredictiveSearchVisible
        document.body.classList[this.isPredictiveSearchVisible ? 'add' : 'remove']('no-scroll__search')
        setTimeout(function(){document.querySelector('input[type="search"]').focus()},10);
      },
      // toggleMinicart() {
      //   this.isMinicartVisible = !this.isMinicartVisible
      //   document.body.classList[this.isMinicartVisible ? 'add' : 'remove']('modal-open')
      // },
      toggleMinicart() {
        this.isMinicartVisible = !this.isMinicartVisible;
        const action = this.isMinicartVisible ? 'add' : 'remove';
        document.body.classList[action]('modal-open');
        document.body.classList[action]('no-scroll');
      },
      accountPopupFallback(e) {
        const { message } = e.detail;

        switch (message) {
          case "header-signin":
            if (!this.hasAccountPopupLogin) {
              window.location.assign('/account/login');
            }
            break;

          case "header-signup":
            if (!this.hasAccountPopupRegister) {
              window.location.assign('/account/register');
            }
            break;
        }
      },
      initLiquidAJaxCart() {
        document.addEventListener("liquid-ajax-cart:request-end", (event) => {
          if (!event?.detail) return;

          const { requestState, cart, previousCart, sections } = event.detail;

          if (requestState.requestType === 'add') {
            if (requestState.responseData?.ok) {
              this.isMinicartVisible = true
              document.body.classList.add('no-scroll');
            }
          }

          // properties[__gc_unique_id] element
          const gcUniqueIdInput = document.querySelector('input[name="properties[__gc_unique_id]"]');
          if (gcUniqueIdInput) {
            gcUniqueIdInput.value = new Date().toLocaleTimeString('en-GB', { hour12: false });
          }

          this.cart = cart
          console.log('event', event);
          window.dispatchEvent(new CustomEvent("minicart:cart-updated", { detail: { cart } }));
        });

        document.addEventListener("fetch-api-cart:request-end", (event) => {
          if (!event?.detail) return;

          const { requestState, cart, showMiniCart = true } = event.detail;
          console.log('event-received', event);
          if (
            requestState.requestType === "fetch" &&
            requestState.responseData?.ok && showMiniCart 
          ) {
            this.isMinicartVisible = true;
          }

          this.cart = cart;
          window.dispatchEvent(new CustomEvent("minicart:cart-updated", { detail: { cart } }));
        });
      },
      onWindowScrollHandler() {
        const isScrolled = window.scrollY > 0

        this.isWindowScrolled = isScrolled
        document.body.classList[isScrolled ? 'add' : 'remove']('scrolled')
      },
      onKeyDownHandler(event) {
          if (event.key === 'Escape') {
              this.isMinicartVisible = false;
              this.isPredictiveSearchVisible = false;
          }
      },
      
      listenToCart() {
        const CART_ENDPOINT_RE = /\/cart(\/(add|update|change|clear)(\.js)?)?$|[\?&]add=/i;
        const isCartMutatingRequest = (url, method = 'GET') =>
          CART_ENDPOINT_RE.test(url) && /post|put|get|patch|delete/i.test(method);

        let ignoreNextFetch = false;
        let pending = false;

        const getCart = async () => {
          try {
            ignoreNextFetch = true;
            const res = await fetch('/cart.js', {
              credentials: 'same-origin',
              headers: { 'Accept': 'application/json' }
            });
            const cart = await res.json();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          } catch (e) {
            console.error('[listenToCartUpdates] Failed to fetch /cart.js', e);
          } finally {
            setTimeout(() => { ignoreNextFetch = false; }, 0);
          }
        };

        const scheduleCartRead = () => {
          if (pending) return;
          pending = true;
          setTimeout(() => {
            pending = false;
            getCart();
          }, 50);
        };

        // Patch fetch
        const originalFetch = window.fetch;
        window.fetch = function patchedFetch(input, init = {}) {
          try {
            const url = typeof input === 'string' ? input : input?.url || '';
            const method = (init?.method || (typeof input !== 'string' ? input?.method : 'GET') || 'GET').toUpperCase();

            if (!ignoreNextFetch && isCartMutatingRequest(url, method) && !/\/cart\.js(\?|$)/.test(url)) {
              return originalFetch.apply(this, arguments).then((resp) => {
                scheduleCartRead();
                return resp;
              });
            }
          } catch (_) {}
          return originalFetch.apply(this, arguments);
        };

        // Patch XHR
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;
        const lastXhrMeta = new WeakMap();

        XMLHttpRequest.prototype.open = function(method, url) {
          lastXhrMeta.set(this, {
            method: (method || 'GET').toString().toUpperCase(),
            url: url.toString()
          });
          return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function() {
          try {
            this.addEventListener('loadend', () => {
              const { method = 'GET', url = '' } = lastXhrMeta.get(this) || {};
              if (!ignoreNextFetch && isCartMutatingRequest(url, method) && !/\/cart\.js(\?|$)/.test(url)) {
                scheduleCartRead();
              }
            });
          } catch (_) {}
          return originalSend.apply(this, arguments);
        };
      }

    }
  }
}
export default global;
